export const DEFAULT_LEGAL_DOCUMENTS = {
  terms: {
    title: 'Általános Szerződési Feltételek',
    content: `Ez egy minta ÁSZF oldal. A végleges szöveghez kérjük, illessz be jogilag megfelelő tartalmat.

A rendelés leadásával a vásárló elfogadja a fizetési, szállítási és elállási feltételeket.

Kérdés esetén írj nekünk: hello@lumenverde.hu.`,
  },
  privacy: {
    title: 'Adatvédelmi Szabályzat',
    content: `A rendelés során megadott adatokat a vásárlás előkészítéséhez és teljesítéséhez használjuk fel.

Kérdés esetén írj nekünk: hello@lumenverde.hu.`,
  },
  withdrawal: {
    title: 'Elállási jog',
    content: `Online elállási funkció

A Lumen Verde az elállási időszak alatt folyamatosan elérhetővé teszi az „Elállás a szerződéstől” online funkciót. A nyilatkozatban megadhatod az elállási döntésedet, a nevedet, az érintett rendelés vagy szerződés azonosítóját, valamint azt az e-mail-címet, amelyre a visszaigazolást kéred.

Az „Elállás megerősítése” gomb használatát követően az elállás tartalmát, valamint az elküldés napját és időpontját tartalmazó átvételi elismervényt küldünk a megadott e-mail-címre.

Egyéb nyilatkozati lehetőségek

Az online funkció nem szünteti meg azt a jogodat, hogy elállási nyilatkozatodat e-mailben, postai úton vagy más egyértelmű nyilatkozattal közöld velünk.

Kérdés esetén írj nekünk: hello@lumenverde.hu.`,
  },
};

export const getDefaultLegalDocument = (documentId) => ({
  fileUrl: '',
  fileName: '',
  fileType: '',
  ...(DEFAULT_LEGAL_DOCUMENTS[documentId] || { title: '', content: '' }),
});
